<svg width="58" height="54" class="pointer-events-none filter drop-shadow-sm w-full h-full">
  <use xlink:href="#logo__pangea__p_only" fill="currentColor">
</svg>